module.exports = __webpack_public_path__ + "img/smiley_4.a69fc33f.png";